import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NotificationElement } from '../notification.model';

@Component({
  selector: 'app-notification-item',
  templateUrl: './notification-item.component.html',
  styleUrl: './notification-item.component.scss',
})
export class NotificationItemComponent {
  @Input() notificationData!: NotificationElement;
  @Input() previousNotification: NotificationElement | null = null;
  @Input() index: number = 0;

  @Output() onMarkAsReadEvent = new EventEmitter<NotificationElement>();
  @Output() openNotificationEvent = new EventEmitter<NotificationElement>();
  @Output() onDeleteNotificationEvent = new EventEmitter<NotificationElement>();

  markAsRead() {
    this.onMarkAsReadEvent.emit(this.notificationData);
  }

  deleteNotification() {
    this.onDeleteNotificationEvent.emit(this.notificationData);
  }

  openNotification() {
    this.openNotificationEvent.emit(this.notificationData);
  }
}
